import { useTranslation } from "react-i18next";
import React from 'react';
import AdminLayout from 'Components/Admin/AdminLayout';
import { Container, Card, CardHeader, CardBody } from 'reactstrap';
export default function ApiEndpoints() {
  const {
    t
  } = useTranslation();
  return <AdminLayout>
      <Container>
        <h2>{t("API Endpoints Documentation")}</h2>
        <p className="text-muted">{t("Complete list of available API endpoints with documentation")}</p>
        
        <Card>
          <CardHeader>
            <h5>{t("Authentication Endpoints")}</h5>
          </CardHeader>
          <CardBody>
            <div className="row">
              <div className="col-md-12">
                <h6>{t("POST /api/auth/login")}</h6>
                <p>{t("User login with email and password")}</p>
                <p><strong>{t("Parameters:")}</strong>{t("email, password")}</p>
                <p><strong>{t("Response:")}</strong>{t("JWT token and user data")}</p>
                <hr />
                
                <h6>{t("POST /api/auth/register")}</h6>
                <p>{t("Register new user account")}</p>
                <p><strong>{t("Parameters:")}</strong>{t("email, password, firstName, lastName")}</p>
                <p><strong>{t("Response:")}</strong>{t("User account created")}</p>
                <hr />
                
                <h6>{t("GET /api/auth/verify")}</h6>
                <p>{t("Verify JWT token validity")}</p>
                <p><strong>{t("Parameters:")}</strong>{t("Authorization header")}</p>
                <p><strong>{t("Response:")}</strong>{t("Token validation status")}</p>
              </div>
            </div>
          </CardBody>
        </Card>

        <Card className="mt-3">
          <CardHeader>
            <h5>{t("User Profile Endpoints")}</h5>
          </CardHeader>
          <CardBody>
            <div className="row">
              <div className="col-md-12">
                <h6>{t("GET /api/users/profile")}</h6>
                <p>{t("Get current user profile with all properties")}</p>
                <p><strong>{t("Auth Required:")}</strong>{t("Yes")}</p>
                <p><strong>{t("Response:")}</strong>{t("Complete user profile data")}</p>
                <hr />
                
                <h6>{t("PUT /api/users/profile")}</h6>
                <p>{t("Update user profile information")}</p>
                <p><strong>{t("Auth Required:")}</strong>{t("Yes")}</p>
                <p><strong>{t("Parameters:")}</strong>{t("profile data")}</p>
                <p><strong>{t("Response:")}</strong>{t("Updated profile data")}</p>
                <hr />
                
                <h6>{t("POST /api/users/profile/property")}</h6>
                <p>{t("Create or update a profile property")}</p>
                <p><strong>{t("Auth Required:")}</strong>{t("Yes")}</p>
                <p><strong>{t("Parameters:")}</strong>{t("name, value, verified")}</p>
                <p><strong>{t("Response:")}</strong>{t("Property created/updated")}</p>
              </div>
            </div>
          </CardBody>
        </Card>

        <Card className="mt-3">
          <CardHeader>
            <h5>{t("Database Endpoints")}</h5>
          </CardHeader>
          <CardBody>
            <div className="row">
              <div className="col-md-12">
                <h6>{t("GET /api/database/tables")}</h6>
                <p>{t("Get list of all database tables")}</p>
                <p><strong>{t("Auth Required:")}</strong>{t("No")}</p>
                <p><strong>{t("Response:")}</strong>{t("Array of table names")}</p>
                <hr />
                
                <h6>{t("GET /api/database/tables/:tableName")}</h6>
                <p>{t("Get data from specific table")}</p>
                <p><strong>{t("Auth Required:")}</strong>{t("No")}</p>
                <p><strong>{t("Parameters:")}</strong>{t("tableName, limit, offset")}</p>
                <p><strong>{t("Response:")}</strong>{t("Table data")}</p>
                <hr />
                
                <h6>{t("PUT /api/database/tables/:tableName/:id")}</h6>
                <p>{t("Update record in table")}</p>
                <p><strong>{t("Auth Required:")}</strong>{t("No")}</p>
                <p><strong>{t("Parameters:")}</strong>{t("tableName, id, data")}</p>
                <p><strong>{t("Response:")}</strong>{t("Record updated")}</p>
              </div>
            </div>
          </CardBody>
        </Card>

        <Card className="mt-3">
          <CardHeader>
            <h5>{t("Status Endpoints")}</h5>
          </CardHeader>
          <CardBody>
            <div className="row">
              <div className="col-md-12">
                <h6>{t("GET /api/status")}</h6>
                <p>{t("Get server status")}</p>
                <p><strong>{t("Auth Required:")}</strong>{t("No")}</p>
                <p><strong>{t("Response:")}</strong>{t("Server status information")}</p>
                <hr />
                
                <h6>{t("GET /health")}</h6>
                <p>{t("Health check endpoint")}</p>
                <p><strong>{t("Auth Required:")}</strong>{t("No")}</p>
                <p><strong>{t("Response:")}</strong>{t("Health status")}</p>
              </div>
            </div>
          </CardBody>
        </Card>

        <div className="mt-4">
          <h5>{t("Summary")}</h5>
          <p>{t("This page shows the main API endpoints available in the system. For a complete list with filtering and search capabilities, the full interactive version will be available once the component issues are resolved.")}</p>
        </div>
      </Container>
    </AdminLayout>;
}